import React from 'react';
import { Route, Switch } from 'react-router';
import { Paths } from '~admin/route';
import { ClientsPage } from '~admin/view/pages/clients.page';
import { CreateEventPage } from '~admin/view/pages/create-event.page';
import { EditEventPage } from '~admin/view/pages/edit-event.page';
import { HomePage } from '~admin/view/pages/home.page';
import { ViewEventsPage } from '~admin/view/pages/view-events.page';

export const ToolRouter: React.FunctionComponent = () => {
  return (
    <Switch>
      <Route exact path={Paths.tool.clients} component={ClientsPage} />
      <Route exact path={Paths.tool.createEvent} component={CreateEventPage} />
      <Route exact path={Paths.tool.editEvent} component={EditEventPage} />
      <Route exact path={Paths.tool.events} component={ViewEventsPage} />
      <Route exact path={Paths.tool.base} component={HomePage} />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./view/components/core/tool-router.component.tsx